"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _palette = _interopRequireDefault(require("./palette"));
require("typeface-lato/index.css");
var _default = {
  fontFamily: ['Lato', 'sans-serif'].join(','),
  h1: {
    color: _palette["default"].text.primary,
    fontWeight: 700,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '40px'
  },
  h2: {
    color: _palette["default"].text.primary,
    fontWeight: 700,
    fontSize: '29px',
    letterSpacing: '-0.24px',
    lineHeight: '32px'
  },
  h3: {
    color: _palette["default"].text.primary,
    fontWeight: 700,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '28px'
  },
  h4: {
    color: _palette["default"].text.primary,
    fontWeight: 700,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px'
  },
  h5: {
    color: _palette["default"].text.primary,
    fontWeight: 700,
    fontSize: '20px',
    letterSpacing: '-0.05px',
    lineHeight: '20px'
  },
  h6: {
    color: _palette["default"].text.primary,
    fontWeight: 700,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px'
  }
  // subtitle1: {
  //   color: palette.text.primary,
  //   fontSize: '16px',
  //   letterSpacing: '-0.05px',
  //   lineHeight: '25px'
  // },
  // subtitle2: {
  //   color: palette.text.secondary,
  //   fontWeight: 400,
  //   fontSize: '14px',
  //   letterSpacing: '-0.05px',
  //   lineHeight: '21px'
  // },
  // body1: {
  //   color: palette.text.primary,
  //   fontSize: '14px',
  //   letterSpacing: '-0.05px',
  //   lineHeight: '21px'
  // },
  // body2: {
  //   color: palette.text.secondary,
  //   fontSize: '12px',
  //   letterSpacing: '-0.04px',
  //   lineHeight: '18px'
  // },
  // button: {
  //   color: palette.text.primary,
  //   fontSize: "12px",
  // },
  // caption: {
  //   color: palette.text.secondary,
  //   fontSize: '11px',
  //   letterSpacing: '0.33px',
  //   lineHeight: '13px'
  // },
};
exports["default"] = _default;